/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-repository-resource-dialog.vue?vue&type=template&id=4c894b7c&"
import script from "./add-repository-resource-dialog.vue?vue&type=script&lang=js&"
export * from "./add-repository-resource-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports